import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Typo from 'uikit/content/components/typo';

import { NavLink } from 'react-router-dom';

import styles from '../styles/uikitManageManagePageNav.module.scss';

const ManagePageNav = ({ items = [] }) => (
  <nav className={styles.element}>
    <ul className={styles.navList}>
      {items.map((item, index) => (
        <Item key={item.id || index} item={item} />
      ))}
    </ul>
  </nav>
);

const Item = ({ item }) => {
  const { id = '', isActive = false, testId = '', text = '', to = '' } = item;
  return (
    <li data-testid={testId} className={styles.navListItem}>
      <NavLink
        activeClassName={styles.navLinkActive}
        className={classnames(styles.navLink, { [styles.navLinkActive]: isActive })}
        id={id}
        to={to}
      >
        <Typo element="div" variant="b01" weight="medium">
          {text}
        </Typo>
      </NavLink>
    </li>
  );
};

ManagePageNav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isActive: PropTypes.bool,
      testId: PropTypes.string,
      text: PropTypes.string.isRequired,
      to: PropTypes.string,
    }),
  ),
};

Item.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isActive: PropTypes.bool,
    testId: PropTypes.string,
    text: PropTypes.string.isRequired,
    to: PropTypes.string,
  }).isRequired,
};

ManagePageNav.Item = Item;

export default ManagePageNav;
